import { createHttpClient } from "@/lib/http-client";

const baseURL = process.env.NEXT_PUBLIC_CANDIDATE_API_URL;
const apiKey = process.env.NEXT_PUBLIC_CANDIDATE_API_KEY;
const secret = process.env.NEXT_PUBLIC_CANDIDATE_API_SECRET;
if (!baseURL || !apiKey || !secret) {
  throw new Error(
    "NEXT_PUBLIC_CANDIDATE_API_URL / NEXT_PUBLIC_CANDIDATE_API_KEY / NEXT_PUBLIC_CANDIDATE_API_SECRET are not configured",
  );
}

// The single global Axios instance for all API calls, talking directly to the
// separate backend service. The request interceptor signs every call with
// x-auth-apikey/x-auth-signature/x-auth-timestamp, matching the backend's
// authenticateApiKey middleware (HMAC-SHA256 of JSON.stringify({timestamp})).
// Uses the Web Crypto API (crypto.subtle) since this file runs in the browser,
// where Node's crypto module isn't available.
export const apiClient = createHttpClient({ baseURL });

async function signHmac(key: string, payload: string): Promise<string> {
  const enc = new TextEncoder();
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    enc.encode(key),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  const signature = await crypto.subtle.sign("HMAC", cryptoKey, enc.encode(payload));
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

apiClient.interceptors.request.use(async (config) => {
  const timestamp = Date.now();
  const signature = await signHmac(secret, JSON.stringify({ timestamp }));
  config.headers.set("x-auth-apikey", apiKey);
  config.headers.set("x-auth-signature", signature);
  config.headers.set("x-auth-timestamp", String(timestamp));
  return config;
});
